var map = {
	"./1.png": "./src/assets/images/home_new/vip/1.png",
	"./10.png": "./src/assets/images/home_new/vip/10.png",
	"./11.png": "./src/assets/images/home_new/vip/11.png",
	"./12.png": "./src/assets/images/home_new/vip/12.png",
	"./13.png": "./src/assets/images/home_new/vip/13.png",
	"./14.png": "./src/assets/images/home_new/vip/14.png",
	"./15.png": "./src/assets/images/home_new/vip/15.png",
	"./2.png": "./src/assets/images/home_new/vip/2.png",
	"./3.png": "./src/assets/images/home_new/vip/3.png",
	"./4.png": "./src/assets/images/home_new/vip/4.png",
	"./5.png": "./src/assets/images/home_new/vip/5.png",
	"./6.png": "./src/assets/images/home_new/vip/6.png",
	"./7.png": "./src/assets/images/home_new/vip/7.png",
	"./8.png": "./src/assets/images/home_new/vip/8.png",
	"./9.png": "./src/assets/images/home_new/vip/9.png",
	"./Rectangle 240663466.png": "./src/assets/images/home_new/vip/Rectangle 240663466.png",
	"./image 2422.png": "./src/assets/images/home_new/vip/image 2422.png",
	"./image 2427.png": "./src/assets/images/home_new/vip/image 2427.png",
	"./image 2430.png": "./src/assets/images/home_new/vip/image 2430.png",
	"./image 2432.png": "./src/assets/images/home_new/vip/image 2432.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/home_new/vip sync recursive ^\\.\\/.*\\.png$";